export enum UserDuelState {
  LOCKED = 0,
  UNLOCKED = 1,
  ONGOING = 2,
  DONE = 3,
  NO_REF_PERIOD_VALID = 4,
}
